<div class="content-section">
    <h4 class="dialog-title" i18n="@@AddressSuggestions" t="AddressSuggestions">Address Suggestions</h4>
    <tsl-radio-group class="sob-radio-group" [(ngModel)]="favoriteSuggestion">
        <tsl-radio-button class="sob-radio-button" *ngFor="let prediction of predictions" [value]="prediction">
            {{ prediction }}
        </tsl-radio-button>
    </tsl-radio-group>
    <div>
        <button tsl-button color="black" (click)="onNoClick()" i18n="@@Ignore" t="Ignore">Ignore</button>
        <button tsl-button color="blue" (click)="acceptSuggestion()" i18n="@@Accept" t="Accept">Accept</button>
    </div>
</div>
